export default __webpack_public_path__ + "static/media/petition.cc9c98cd.svg";